import { render } from "./TgSlidePanel.vue?vue&type=template&id=7bbfc2ba"
import script from "./TgSlidePanel.vue?vue&type=script&lang=js"
export * from "./TgSlidePanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__